import GenericLoader from "./GenericLoader";
import { createRoot } from "react-dom/client";

declare const $: any;

export class LoadingHelper {
  private static readonly containerClass = "global-loader-main-container";

  public static showLoader(selecter: string): void {
    const element = document.querySelector(selecter);
    if (!element) {
      return;
    }

    element.querySelector("." + this.containerClass)?.remove();

    const container = document.createElement("div");
    container.className = this.containerClass;
    container.style.position = "absolute";
    container.style.width = "100%";
    container.style.height = "100%";
    container.style.top = "0";
    container.style.left = "0";
    element.appendChild(container);

    const root = createRoot(container);
    root.render(GenericLoader());
  }

  public static hideLoader(selecter: string): void {
    const element = document.querySelector(selecter);
    if (!element) {
      return;
    }

    element.querySelector("." + this.containerClass)?.remove();
  }
}
